module.exports = __webpack_public_path__ + "static/media/paper.b9f2d9f0.png";